/* tslint:disable */
import { defineMessages } from 'react-intl';

export default defineMessages({
    noResultsMessageDefault: {
        defaultMessage: 'Sorry, currently there are no events available for betting.',
        id: 'components.NoResults'
    },
    noResultsMessageMore: {
        defaultMessage: 'Please enter at least two characters in order to search',
        id: 'components.NoResults/More'
    },
    noResultsMessageSearch: {
        defaultMessage: 'Sorry, we couldn\'t find anything matching your search! Please try different criteria',
        id: 'components.yNoResults/Search'
    },
    noResultsMessagePage: {
        defaultMessage: 'Sorry, currently there are no events available for this page. Please try different page',
        id: 'components.NoResults/Page'
    },
    noResultsMessageTryAgain: {
        defaultMessage: 'Try again',
        id: 'components.NoResults/TryAgain'
    }
});